<mat-form-field [formGroup]="group"
                appearance="fill"
                fxFlex>
  <mat-label>{{field.label}}</mat-label>
  <input matInput
         [matDatepicker]="picker"
         [formControlName]="field.name"
         [placeholder]="field.label">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <mat-hint></mat-hint>
  <ng-container
    *ngFor="let validation of field.validations;"
    ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name)?.hasError(validation.name)"
               [translate]="validation.message"
               [translateParams]="{field:field.label}">
    </mat-error>
  </ng-container>
</mat-form-field>
